import { Group, Text, Burger, Drawer, Stack } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { Link, NavLink } from "react-router-dom";

const NAV: Array<{ to: string; label: string }> = [
  { to: "/", label: "Home" },
  { to: "/releases", label: "Releases" },
  { to: "/live", label: "Live" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

function NavItem({ to, label, onClick }: { to: string; label: string; onClick?: () => void }) {
  return (
    <NavLink
      to={to}
      end={to === "/"}
      onClick={onClick}
      style={({ isActive }) => ({
        fontWeight: 500,
        letterSpacing: "0.06em",
        textTransform: "uppercase",
        fontSize: "0.85rem",
        color: isActive ? "var(--color-starlight)" : "var(--color-foam)",
        padding: "0.5rem 0",
      })}
    >
      {label}
    </NavLink>
  );
}

export function Header() {
  const [opened, { toggle, close }] = useDisclosure(false);

  return (
    <Group h="100%" px="md" justify="space-between">
      <Link to="/" style={{ textDecoration: "none" }}>
        <Text
          fw={700}
          size="lg"
          style={{ letterSpacing: "0.06em", color: "var(--color-starlight)" }}
        >
          7 MINUTES DEAD
        </Text>
      </Link>

      <Group gap="lg" visibleFrom="sm">
        {NAV.map((item) => (
          <NavItem key={item.to} {...item} />
        ))}
      </Group>

      <Burger opened={opened} onClick={toggle} hiddenFrom="sm" color="var(--color-starlight)" />

      <Drawer
        opened={opened}
        onClose={close}
        title="Menu"
        position="right"
        size="xs"
      >
        <Stack gap="md">
          {NAV.map((item) => (
            <NavItem key={item.to} {...item} onClick={close} />
          ))}
        </Stack>
      </Drawer>
    </Group>
  );
}
